const MFA_LOGIN_KEY = "@UltragazEmpresarial:X-Mfa-Login";

export function clearMfaLoginMarker(): void {
  sessionStorage.removeItem(MFA_LOGIN_KEY);
}
